var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "UI_icon_logout_light",
    "data-name": "UI icon/logout/light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.086,
    height: 20,
    viewBox: "0 0 18.086 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M9.707.293A1,1,0,1,0,8.293,1.707L10.086,3.5H1a1,1,0,0,0,0,2h9.086L8.293,7.293A1,1,0,0,0,9.707,8.707L12.5,5.914a2,2,0,0,0,0-2.828Z",
    transform: "translate(5 5.5)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_587_Stroke_",
    "data-name": "Vector 587 (Stroke)",
    d: "M0,3A3,3,0,0,1,3,0H9a3,3,0,0,1,3,3V4a1,1,0,0,1-2,0V3A1,1,0,0,0,9,2H3A1,1,0,0,0,2,3V17a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V16a1,1,0,0,1,2,0v1a3,3,0,0,1-3,3H3a3,3,0,0,1-3-3Z",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ea6186786762ae8784b1c54421ec69f2.svg";
export { ForwardRef as ReactComponent };